// kitchen order list 

import httpClient from '@/http-client'

export const orderList = (Options = {}) => {
  return httpClient
    .get('/api/v1/kitchen-order-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/kitchen-order-lists/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const group = (Options = {}) => {
  return httpClient
    .get('/api/v1/kitchen-order-lists/product-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  orderList, update, group
}
